// extracted by css-extract-rspack-plugin
export default {"UserList":"styles-module__UserList"};